module.exports = __webpack_public_path__ + "img/card-Onhold.07c3d750.svg";